module.exports = __webpack_public_path__ + "img/banner_4.6ac62399.png";